import React from 'react';
import { ListDetailViewProps } from './types';
import { styles } from './styles';

const ListDetailView: React.FC<ListDetailViewProps> = ({
  selectedId,
  list,
  detail,
}) => {
  return (
    <div className={styles.container}>
      <div className={selectedId ? styles.listContainerSplit : styles.listContainerFull}>
        {list}
      </div>
      {selectedId && detail}
    </div>
  );
};

export default ListDetailView;
export type { ListDetailViewProps } from './types';
